import { useRef, useState } from 'react'
import { Turnstile } from "@marsidev/react-turnstile";

type FormState = {
  name: string
  email: string
  phone: string
  business: string
  type: string
  message: string
  website: string
  turnstileToken: string
}

const initialForm: FormState = {
  name: '',
  email: '',
  phone: '',
  business: '',
  type: 'General',
  message: '',
  website: '',
  turnstileToken: '',
}

export default function ContactForm() {
  const [form, setForm] = useState<FormState>(initialForm)
  const [state, setState] = useState<{ status: 'idle' | 'loading' | 'success' | 'error'; message: string }>({
    status: 'idle',
    message: '',
  })

  const turnstileRef = useRef<any>(null);

  const update = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = event.target
    setForm((current) => ({ ...current, [name]: value }))
  }

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setState({ status: 'loading', message: 'Sending…' })

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      })

      const result = (await response.json().catch(() => ({}))) as { error?: string }
      if (!response.ok) throw new Error(result.error || 'Unable to send your enquiry.')

      setForm(initialForm)
      turnstileRef.current?.reset();
      setState({ status: 'success', message: 'Thanks — your enquiry has been sent.' })
    } catch (error) {
      setState({
        status: 'error',
        message: error instanceof Error ? error.message : 'Something went wrong. Please email Em directly.',
      })
    }
  }

  return (
    <form className="contact-form" onSubmit={submit}>
      <div className="form-row">
        <label>Name<input name="name" value={form.name} onChange={update} required maxLength={100} /></label>
        <label>
          Enquiry type
          <select name="type" value={form.type} onChange={update}>
            <option>General</option>
            <option>Partnership</option>
            <option>Car or driver appearance</option>
            <option>Media</option>
          </select>
        </label>
        
        
      </div>
      <div className="form-row">
        <label>Phone<input name="phone" type="tel" value={form.phone} onChange={update} maxLength={40} /></label>
        <label>Business / organisation<input name="business" value={form.business} onChange={update} maxLength={150} /></label>
      </div>
      <label>Email<input name="email" type="email" value={form.email} onChange={update} required maxLength={200} /></label>
      
      <label>Message<textarea name="message" rows={7} value={form.message} onChange={update} required maxLength={3000} /></label>
      <input className="honeypot" name="website" value={form.website} onChange={update} tabIndex={-1} autoComplete="off" aria-hidden="true" />
      <Turnstile
        ref={turnstileRef}
        siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
        onSuccess={(token) =>
          setForm((current) => ({
            ...current,
            turnstileToken: token,
          }))
        }
        onExpire={() =>
          setForm((current) => ({
            ...current,
            turnstileToken: "",
          }))
        }
      />
      <div className="submit-row">
        <button className="button button-primary" disabled={
          state.status === "loading" ||
          !form.turnstileToken
        }>
          {state.status === 'loading' ? 'Sending…' : 'Send enquiry'}
        </button>
        <p className={state.status} role="status" aria-live="polite">{state.message}</p>
      </div>
    </form>
  )
}
